import { render, staticRenderFns } from "./listaCursos.vue?vue&type=template&id=7617ddc1"
import script from "./listaCursos.vue?vue&type=script&lang=js"
export * from "./listaCursos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports